import type { ReactNode } from 'react';
import styles from './SectionCard.module.css';

interface SectionCardProps {
  title: string;
  subtitle?: string;
  description?: string;
  actions?: ReactNode;
  footer?: ReactNode;
  bleed?: boolean;
  children: ReactNode;
}

export function SectionCard({
  title,
  subtitle,
  description,
  actions,
  footer,
  bleed = false,
  children,
}: SectionCardProps) {
  return (
    <section className={styles.card} data-testid="section-card">
      <div className={styles.header}>
        <div className={styles.titleGroup}>
          <h2 className={styles.title}>{title}</h2>
          {subtitle && <span className={styles.subtitle}>{subtitle}</span>}
        </div>
        {actions && <div className={styles.actions}>{actions}</div>}
      </div>
      {description && <p className={styles.description}>{description}</p>}
      <div className={bleed ? styles.bodyBleed : styles.body}>{children}</div>
      {footer && <div className={styles.footer}>{footer}</div>}
    </section>
  );
}
